import React from 'react'

const About = () => {
    return (
        <div id="About" className="section about-sec">
            <div className="flex flex-col items-center justify-center w-full ">
                <p className="cursive title-top">About me</p>
                <div className="flex justify-center items-center">
                    <p className="sm:text-lg ">
                        I am a passionate full-stack developer with over 3 years of
                        experience in building and maintaining web applications.
                        Currently, I am delving into the realms of DevOps and open-source
                        contributions, enhancing my understanding of real-world projects,
                        infrastructure, and continuous integration/deployment processes. I
                        am proud to be an LFX mentee at LitmusChaos, where I am honing my
                        skills in chaos engineering and GitOps. I am eager to leverage my
                        skills in full-stack development and my growing expertise in
                        DevOps to contribute to impactful projects. Collaboration and
                        continuous learning are at the core of my professional ethos, and
                        I am always open to new opportunities to grow and make a
                        difference in the tech community.
                    </p>
                </div>
            </div>
            {/* <h1>Section 2</h1> */}
            {/* <Hero /> */}
            {/* <a href="#Project" className="js-anchor-link">
      Go to section 3
    </a> */}
        </div>
    )
}

export default About